import { render, staticRenderFns } from "./EmailBodyEditor.vue?vue&type=template&id=29f538f6&scoped=true"
import script from "./EmailBodyEditor.vue?vue&type=script&lang=js"
export * from "./EmailBodyEditor.vue?vue&type=script&lang=js"
import style0 from "./EmailBodyEditor.vue?vue&type=style&index=0&id=29f538f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f538f6",
  null
  
)

export default component.exports